import styled from "@emotion/styled";
export const LoadingWrapper = styled.div(({state}) => ({
  display: "none",
  ...(state === "loading" && {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "white",
    zIndex: 999,
  }),
}));
